import type { PayrollConceptSelectFieldFragment } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import { AdditionalCompensationWizardModal } from 'modules/contracts/components/FlowPage/Steps/RoleLevelSalary/_AdditionalCompensations/AdditionalCompensationWizard/AdditionalCompensationWizardModal'
import { replaceAdditionalCompensationInList } from 'modules/contracts/components/FlowPage/Steps/RoleLevelSalary/_AdditionalCompensations/lib/additionalCompensationList'
import {
  type InMemoryAdditionalCompensation,
  useContractFlow,
} from 'modules/contracts/lib/contractFlowContext'

type EditAdditionalCompensationWizardModalProps = {
  additionalCompensation: InMemoryAdditionalCompensation
  payrollConcepts: PayrollConceptSelectFieldFragment[]
  onClose?: () => void
  effectiveOn?: string
}

function EditAdditionalCompensationWizardModal({
  onClose,
  additionalCompensation,
  payrollConcepts,
  effectiveOn,
}: EditAdditionalCompensationWizardModalProps) {
  const { additionalCompensations, setAdditionalCompensations } = useContractFlow()

  return (
    <AdditionalCompensationWizardModal
      onClose={onClose}
      formName="edit-additional-compensation-wizard"
      submitLabel={i18n.t(
        'contract_versions.additional_compensation.edit_additional_compensation_form_modal.save'
      )}
      title={i18n.t(
        'contract_versions.additional_compensation.edit_additional_compensation_form_modal.title'
      )}
      payrollConcepts={payrollConcepts}
      effectiveOn={effectiveOn}
      contractVersionId={additionalCompensation.contractVersionId}
      additionalCompensation={additionalCompensation}
      onSave={(editedAdditionalCompensation) => {
        setAdditionalCompensations(
          replaceAdditionalCompensationInList(
            additionalCompensations ?? [],
            editedAdditionalCompensation
          )
        )

        track(trackingEvents.compensations.updateCompensation, {
          type: 'contract',
          compensationId: editedAdditionalCompensation.id || editedAdditionalCompensation.tmpID,
        })
      }}
    />
  )
}

export { EditAdditionalCompensationWizardModal }
